import React from "react";
import Button from "../Button";
import SimpleModal from "./SimpleModal";
import { Title, SubLabel } from "./styles";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  onConfigure: () => void;
}

const PersuasionModalLogin: React.FC<Props> = ({
  isOpen,
  toggle,
  onConfigure,
}) => {
  const handleRemindLater = () => {
    const today = new Date();
    localStorage.setItem("mfa_persuasion_date", today.toISOString());
    toggle();
  };

  return (
    <SimpleModal isOpen={isOpen} onClose={toggle} title="" size="md">
      <div style={{ padding: "24px" }} className="modal-content-responsive">
        <Title>
          Se encuentra disponible una nueva configuración de seguridad para tu
          cuenta
        </Title>

        <div style={{ marginTop: "24px" }}>
          <h5 style={{ fontSize: "18px", fontWeight: "600", marginBottom: "12px" }}>
            ¿Qué es?
          </h5>
          <SubLabel>
            La identificación en dos pasos es un sistema para confirmar que
            realmente eres tú quien está accediendo a una cuenta.
          </SubLabel>

          <h5
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "12px",
              marginTop: "16px",
            }}
          >
            ¿Para qué sirve?
          </h5>
          <SubLabel>
            Esta capa de seguridad sirve para evitar que otras personas puedan
            acceder a tu cuenta, incluso en el caso de que hayan conseguido
            averiguar la contraseña que utilizas de alguna manera.
          </SubLabel>

          <h5
            style={{
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "12px",
              marginTop: "16px",
            }}
          >
            ¿Cómo lo hago?
          </h5>
          <SubLabel>
            Tras escribir tu nombre y contraseña en la plataforma, tendrás que
            verificar tu identidad con el código que se te genera en la
            aplicación de verificación en dos pasos que tengas configurada.
          </SubLabel>

          <h5
            style={{
              fontSize: "18px",
              fontWeight: "600",
              textAlign: "center",
              marginTop: "24px",
            }}
          >
            ¡Configúralo ahora!
          </h5>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          gap: "12px",
          padding: "0 24px 24px",
        }}
        className="modal-footer-responsive"
      >
        <Button
          type="button"
          options={{ skin: "secondary", size: "md", type: "filled" }}
          onClick={handleRemindLater}
        >
          Recordarme más tarde
        </Button>
        <Button
          type="button"
          options={{ skin: "primary", size: "md", type: "filled" }}
          onClick={onConfigure}
        >
          Configurar ahora
        </Button>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .modal-content-responsive {
            padding: 16px !important;
          }
          .modal-footer-responsive {
            flex-direction: column !important;
            padding: 0 16px 16px !important;
          }
          .modal-footer-responsive button {
            width: 100%;
          }
        }
      `}</style>
    </SimpleModal>
  );
};

export default PersuasionModalLogin;
